


(function () {
  // Cartbot injects its cart drawer title as <h1>, creating a duplicate top-level
  // heading on every page. Demote it to <h2> to restore a valid heading outline.
  function demoteCartbotHeading() {
    document.querySelectorAll('h1.dyn-cart-heading-title').forEach(function (h1) {
      var h2 = document.createElement('h2');
      h2.innerHTML = h1.innerHTML;
      for (var i = 0; i < h1.attributes.length; i++) {
        var attr = h1.attributes[i];
        h2.setAttribute(attr.name, attr.value);
      }
      h1.replaceWith(h2);
    });
  }

  // Pandectes GDPR cookie consent renders preference checkboxes (pref_1, pref_2,
  // pref_4, ...) with no <label>, aria-label, or aria-labelledby. Add a name
  // sourced from the nearest visible heading; fall back to common category names.
  var pandectesFallback = {
    pref_1: 'Functional cookies',
    pref_2: 'Analytics cookies',
    pref_3: 'Personalization cookies',
    pref_4: 'Marketing cookies',
  };
  function labelPandectesCheckboxes() {
    var inputs = document.querySelectorAll(
      'input[type="checkbox"][name^="pref_"]'
    );
    var assigned = new Set();
    inputs.forEach(function (cb) {
      var current = cb.getAttribute('aria-label');
      // Re-label if missing OR if it's the shared "Manage consent preferences" string.
      if (current && current !== 'Manage consent preferences' && current.trim() !== '') {
        return;
      }
      // Prefer per-checkbox local text: the row/group container holding this input.
      var row = cb.closest(
        '[class*="row"], [class*="item"], [class*="group"], [class*="purpose"], [class*="category"], li, fieldset'
      );
      var name;
      if (row) {
        // Find a heading or label-like element scoped to this row only.
        var candidate = row.querySelector(
          'legend, h2, h3, h4, h5, h6, [class*="title"], [class*="heading"], [class*="name"], [class*="label"]'
        );
        if (candidate && candidate.textContent.trim()) {
          name = candidate.textContent.trim();
        }
      }
      // Fall back to fixed mapping by name (works even before UI text is in DOM).
      if (!name || assigned.has(name)) {
        name = pandectesFallback[cb.name] || 'Cookie preference (' + cb.name + ')';
      }
      assigned.add(name);
      cb.setAttribute('aria-label', name);
    });
  }

  // Textareas inside admin-managed page content (e.g. /pages/contact) ship with
  // no <label> or aria-label. Use placeholder, nearest preceding label/heading,
  // or a humanized name attribute as a fallback.
  function humanize(s) {
    return s.replace(/[_-]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }).trim();
  }
  function labelOrphanedFields() {
    var fields = document.querySelectorAll(
      'textarea:not([aria-label]):not([aria-labelledby]), ' +
      'input[type="email"]:not([aria-label]):not([aria-labelledby]), ' +
      'input[type="text"]:not([aria-label]):not([aria-labelledby]), ' +
      'input[type="tel"]:not([aria-label]):not([aria-labelledby]), ' +
      'input[type="search"]:not([aria-label]):not([aria-labelledby])'
    );
    fields.forEach(function (f) {
      if (f.id && document.querySelector('label[for="' + f.id + '"]')) return;
      if (f.closest('label')) return;
      var name = (f.placeholder && f.placeholder.trim()) || '';
      if (!name) {
        var prev = f.previousElementSibling;
        while (prev) {
          if (/^(LABEL|H[1-6]|P|SPAN|DIV)$/.test(prev.tagName) && prev.textContent.trim()) {
            name = prev.textContent.trim();
            break;
          }
          prev = prev.previousElementSibling;
        }
      }
      if (!name && f.name) name = humanize(f.name);
      if (name) f.setAttribute('aria-label', name);
    });
  }

  // Flickity carousels are initialized via JS and ship without ARIA. Once
  // Flickity adds the .flickity-enabled class to a wrapper, label it as a
  // carousel and mark the slider track as a live region.
  function addCarouselAria() {
    var SELECTORS = [
      '.flickity-enabled',
      '.cx-flickity-carousel',
      '.slick-slider',
      '.slick-slider-nav',
      '[data-replo-carousel="true"]',
      '[data-flickity]',
      'flickity-carousel',
    ];
    document.querySelectorAll(SELECTORS.join(',')).forEach(function (el) {
      if (el.getAttribute('aria-roledescription') === 'carousel') return;
      el.setAttribute('aria-roledescription', 'carousel');
      if (!el.hasAttribute('aria-label')) {
        var section = el.closest('section, .section, [class*="section-"]');
        var heading = section && section.querySelector('h1, h2, h3, .heading');
        el.setAttribute('aria-label', (heading && heading.textContent.trim()) || 'Carousel');
      }
      var track = el.querySelector(
        '.flickity-viewport .flickity-slider, .flickity-slider, .slick-track, .slick-list'
      );
      if (track && !track.hasAttribute('aria-live')) {
        track.setAttribute('aria-live', 'polite');
      }
    });
  }

  // Cartbot's payment modal close button (.dyn-payment-modal-close-button)
  // renders sitewide with no accessible name. Without it, keyboard/screen
  // reader users cannot dismiss the modal.
  function labelPaymentModalClose() {
    document
      .querySelectorAll('.dyn-payment-modal-close-button:not([aria-label])')
      .forEach(function (btn) {
        btn.setAttribute('aria-label', 'Close payment modal');
        btn.querySelectorAll('svg').forEach(function (svg) {
          svg.setAttribute('aria-hidden', 'true');
        });
      });
  }

  // Respect prefers-reduced-motion: pause autoplaying background videos so
  // motion-sensitive users aren't forced to watch them.
  function pauseAutoplayIfReducedMotion() {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('video[autoplay]:not([data-autoplay-banner-video]').forEach(function (v) {
      try { v.pause(); v.removeAttribute('autoplay'); } catch (e) {}
    });
  }

  // Imgs missing the alt attribute entirely fail WCAG 1.1.1 even if decorative.
  // Empty alt="" is the correct decorative pattern. This safety net ensures no
  // img has zero alt attribute. Real (meaningful) alt should still come from the
  // Shopify admin / template.
  // Empty links to /pages/shipping-policy ship from admin-edited content
  // without accessible text. Add aria-label safety net.
  // Some Add-to-Cart buttons (e.g. from Replo blocks) ship without aria-label
  // and share the generic "Add to cart" text. Walk up to find the product
  // container and synthesize a contextual label.
  // Remove empty headings — they bloat the heading outline and confuse
  // screen reader navigation (1.3.1).
  function removeEmptyHeadings() {
    document.querySelectorAll('h1, h2, h3, h4, h5, h6,.dyn-heading-text-left,.dyn-heading-text-right').forEach(function (h) {
      //if (h.closest('[id^="alia-"]')) return;
      if (!h.textContent.trim() && !h.querySelector('img[alt]:not([alt=""])')) {
        h.remove();
      }
    });
  }

  function labelOrphanedATC() {
    var buttons = document.querySelectorAll('button[type="submit"]:not([aria-label])');
    buttons.forEach(function (btn) {
      if (btn.hasAttribute('aria-label') || btn.hasAttribute('aria-labelledby')) return;
      var txt = btn.textContent.trim().toLowerCase();
      if (!/add.*cart/.test(txt)) return;

      // Try several strategies to find a product title.
      var title = '';

      // 1. Closest known product container with a title element inside.
      var ctx = btn.closest('[data-product-id], [data-productid], [data-replo-product-container], [class*="product-item"], [class*="product-card"], [class*="product__"], product-form, [data-product-handle]');
      if (ctx) {
        var titleEl = ctx.querySelector(
          '[class*="product-title"], [class*="product__title"], [class*="product-item-meta__title"], [class*="product-card__title"]'
        );
        if (titleEl) title = titleEl.textContent.trim();
        if (!title && ctx.dataset.productHandle) title = ctx.dataset.productHandle.replace(/-/g, ' ');
      }

      // 2. Walk up DOM looking for nearest heading or product-handle metadata.
      if (!title) {
        var node = btn.parentElement;
        var depth = 0;
        while (node && depth < 10) {
          if (node.dataset && node.dataset.productHandle) {
            title = node.dataset.productHandle.replace(/-/g, ' ');
            break;
          }
          var heading = node.querySelector('h1, h2, h3, h4, [class*="title"]:not([class*="title-bar"])');
          if (heading && heading.textContent.trim().length > 2 && heading.textContent.trim().length < 80) {
            title = heading.textContent.trim();
            break;
          }
          node = node.parentElement;
          depth++;
        }
      }

      btn.setAttribute('aria-label', title ? ('Add ' + title + ' to cart') : 'Add to cart');
    });
  }

  function labelEmptyLinks() {
    document.querySelectorAll('a[href]:not([aria-label])').forEach(function (a) {
      var hasText = a.textContent && a.textContent.trim();
      var hasImg = a.querySelector('img[alt]:not([alt=""])');
      if (hasText || hasImg) return;
      var href = a.getAttribute('href') || '';
      if (/shipping-policy/.test(href)) {
        a.setAttribute('aria-label', 'Shipping policy');
      } else if (/privacy-policy/.test(href)) {
        a.setAttribute('aria-label', 'Privacy policy');
      } else if (/terms/.test(href)) {
        a.setAttribute('aria-label', 'Terms of service');
      } else if (/refund/.test(href)) {
        a.setAttribute('aria-label', 'Refund policy');
      }
    });
  }

  function ensureImgAltAttribute() {
    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      //if (img.closest('[id^="alia-"]')) return;
      img.setAttribute('alt', '');
    });
  }

  // Cartbot's cart close button contains an <img> with no alt attribute.
  // Screen readers announce the raw filename. Mark it decorative since the
  // button itself already has an accessible label via its text or aria-label.
  function fixCartbotCloseImg() {
    document.querySelectorAll('.dyn-cart__close img, [class*="dyn-"][class*="close"] img').forEach(function (img) {
      if (!img.hasAttribute('alt')) {
        img.setAttribute('alt', '');
      }
    });
  }

  var FOCUSABLE_SELECTORS = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  // Flickity sets aria-hidden="true" on off-screen carousel cells but does NOT
  // remove focus from their interactive children. Keyboard users can tab into
  // invisible content. When a cell becomes aria-hidden, add tabindex="-1" to
  // all focusable descendants. Restore when aria-hidden is removed.
  function manageAriaHiddenCarouselCells() {
    var cells = document.querySelectorAll(
      '.flickity-slider > *, .cx-flickity-slider > *, [data-flickity] > *, .flickity-carousel > *'
    );
    cells.forEach(function (cell) {
      // Skip product card swatch carousels — all swatches must remain keyboard-accessible
      // even when off-screen, since users need to select color/size options.
      if (cell.closest('.pcf--size')) return;
      if (cell.getAttribute('aria-hidden') === 'true') {
        cell.querySelectorAll(FOCUSABLE_SELECTORS).forEach(function (el) {
          if (!el.hasAttribute('data-a11y-tabindex-saved')) {
            el.setAttribute('data-a11y-tabindex-saved', el.getAttribute('tabindex') || '');
          }
          el.setAttribute('tabindex', '-1');
        });
      } else {
        cell.querySelectorAll('[data-a11y-tabindex-saved]').forEach(function (el) {
          var saved = el.getAttribute('data-a11y-tabindex-saved');
          if (saved === '') {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', saved);
          }
          el.removeAttribute('data-a11y-tabindex-saved');
        });
      }
    });
  }
  //missing alt on page builders
  function fixPageBuilderAlt() {

    document.querySelectorAll(
      '.instant-image__main:not([alt]), .instant-image__main[alt=""]'
    ).forEach(function(img){

      let alt =
        img.dataset.alt ||
        img.getAttribute("aria-label") ||
        img.getAttribute("title") ||
        "";

      if(!alt){

        const heading =
          img.closest("section,div")
            ?.querySelector("h1,h2,h3");

        if(heading){
          alt = heading.textContent.trim();
        }

      }

      if(!alt){
        alt = document.title.split("|")[0].trim();
      }

      if(alt){
        img.alt = alt;
      }

    });

  }
  function fixEmptySwatchLabels() {

    document.querySelectorAll("label").forEach(function(label){

      if (label.textContent.trim()) return;

      const id = label.getAttribute("for");

      if (!id) return;

      const input = document.getElementById(id);

      if (!input) return;

      // Input already has accessible name
      if (input.getAttribute("aria-label")) {

        label.setAttribute("aria-hidden","true");

        label.setAttribute("role","presentation");

      }

    });

  }
function fixEmptyLabels() {

    document.querySelectorAll("label[for]").forEach(label => {

        if (label.textContent.trim()) return;

        const input = document.getElementById(label.htmlFor);
        if (!input) return;

        const text =
            input.getAttribute("aria-label") ||
            input.placeholder ||
            (input.name
                ? input.name.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
                : "");

        if (text) {
            label.textContent = text;
        }

    });

}

  //contact form
  function fixDatepickerButtons() {
    document.querySelectorAll(".xdsoft_prev").forEach(btn => {
      btn.setAttribute("aria-label", "Previous month");
    });

    document.querySelectorAll(".xdsoft_next").forEach(btn => {
      btn.setAttribute("aria-label", "Next month");
    });

    document.querySelectorAll(".xdsoft_today_button").forEach(btn => {
      btn.setAttribute("aria-label", "Go to today");
    });
  }

  // Initial delayed run
  window.addEventListener("load", () => {
    setTimeout(fixDatepickerButtons, 3000);
  });


  function runFixes() {
    demoteCartbotHeading();
    labelPandectesCheckboxes();
    labelOrphanedFields();
    addCarouselAria();
    labelPaymentModalClose();
    ensureImgAltAttribute();
    fixCartbotCloseImg();
    labelOrphanedATC();
    labelEmptyLinks();
    removeEmptyHeadings();
    pauseAutoplayIfReducedMotion();
    manageAriaHiddenCarouselCells();
    fixPageBuilderAlt();
    fixEmptyLabels();
    fixEmptySwatchLabels();

    console.log('a11yfixes');
  }

function runAllA11yFixes() {

    runFixes();

    fixVariousIssues();

    fixMegamenuImageAlt();

    fixDuplicateRadioLabels();

    fixDatepickerButtons();

}

runAllA11yFixes();



})();

function fixVariousIssues() {

  document.querySelectorAll('input[name="quantity"]').forEach(input => {

    if (
      input.labels?.length ||
      input.hasAttribute("aria-label") ||
      input.hasAttribute("aria-labelledby")
    ) return;

    input.setAttribute("aria-label", "Quantity");

  });
  //for reviews app stamped-review-header-title
  document.querySelectorAll(".stamped-review-header-title:empty").forEach(el => el.remove());

   //empty label in rewards form
   // Fix orphaned Stamped Rewards labels
      document.querySelectorAll('.stamped-rewards-page-buttonAddon label').forEach(label => {
        if (label.hasAttribute('htmlfor')) {
            label.setAttribute('for', label.getAttribute('htmlfor'));
            label.removeAttribute('htmlfor');
        }
    });
   
  //empty label/no label in contact form
  // Fix ECF textareas missing ids
  document.querySelectorAll('.cs-form-wrap textarea').forEach(textarea => {
      if (!textarea.id && textarea.name) {
          textarea.id = textarea.name;
      }
  });

}
//megamenu alt image fix
function fixMegamenuImageAlt() {
  document
    .querySelectorAll('a.megamenu-image_banner img:not([alt]), a.megamenu-image_banner img[alt=""]')
    .forEach(img => {

      const link = img.closest("a");
      if (!link) return;

      let alt = link.textContent.trim();

      if (!alt && link.href) {
        alt = link.href
          .split("/")
          .pop()
          .split("?")[0]
          .split("#")[0]
          .replace(/[-_]+/g, " ")
          .replace(/\b\w/g, c => c.toUpperCase());
      }

      if (alt) {
        img.alt = alt;
      }
    });
    console.log('megamenu image alt added');

    //for empty button
    document.querySelectorAll(
      '.popover-button[aria-controls="sort-by-popover"]'
    ).forEach(btn => {

      const value = btn.querySelector('#sort-by-selected-value')?.textContent.trim();

      btn.setAttribute(
        'aria-label',
        value ? `Sort by: ${value}` : 'Sort products'
      );

    });

    
}
function fixDuplicateRadioLabels() {
  document.querySelectorAll('input[type="radio"]').forEach(input => {
    if (
      input.hasAttribute('aria-label') &&
      document.querySelector(`label[for="${input.id}"]`)
    ) {
      input.removeAttribute('aria-label');
    }
  });
}

setTimeout(function () {

    fixDuplicateRadioLabels();

    fixVariousIssues();

}, 3000);


//target page builder page only
if (window.location.pathname === "/pages/clear-bundles-fb-bpage-a1") {

  setTimeout(() => {

    const style = document.createElement("style");

    style.textContent = `
      .instant-variant-picker label {
        font-size: 0 !important;
      }

      .__instant.ikHEsG4ollbHjH1IU .i04d8vcKoYg50bn4n,
      .__instant.ikHEsG4ollbHjH1IU .i1kxuRFdYNhwFLBrG {
        background: #ab0606 !important;
      }

      span.iI1OhvJiU5TBTsclD,
      h3.itXueEXPJODioZjhn {
        color: #353535 !important;
      }
      .__instant.ikHEsG4ollbHjH1IU .iBwJL8UYcGOnbzaKR,
      .__instant.ikHEsG4ollbHjH1IU .i06cIzAsibvjrIUup{
        background: #ab0606 !important;
      }
    `;

    document.head.appendChild(style);

  }, 1000);

}

/* FIX FOR THE CART NUMBER NOT UPDATING 
(function () {

  async function updateCartCount() {

    try {

      const response = await fetch('/cart.js');
      const cart = await response.json();

      const count = cart.item_count || 0;

      document.querySelectorAll('.dyn-heading-text-right').forEach(el => {
        el.textContent = `(${count})`;
      });

    } catch (e) {
      console.log('Cart count update failed', e);
    }
  }

  // initial
  updateCartCount();

  // observe DOM rerenders
  const observer = new MutationObserver(() => {
    updateCartCount();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

*/

/* FIX for quick view not opening */
$(document).on("click", ".quickview_btn", function (e) {

    e.preventDefault();

    const modalId = $(this).data("modal");

    if (!modalId) return;

    $("#" + modalId)
        .css("display", "block")
        .addClass("active");

    $("body").addClass("overflow-hidden");

});

$(document).on("click", ".quickview_close, .pdp_quickview_close", function () {

    $(this)
        .closest(".quickview_modal")
        .removeClass("active")
        .hide();

    $("body").removeClass("overflow-hidden");

});
$(document).on("click", ".collection-quickview .block-swatch__item", function () {

    const $modal = $(this).closest(".collection-quickview");

    // Update active state
    const $list = $(this).closest(".block-swatch-list");
    $list.find(".block-swatch__item").removeClass("active");
    $(this).addClass("active");

    // Get selected options
    const selected = [];

    $modal.find(".block-swatch-list").each(function () {

        const value = $(this)
            .find(".block-swatch__item.active")
            .siblings("input")
            .val();

        if (value) {
            selected.push(value);
        }  

    });

    // Find matching variant
    const $variant = $modal.find(".quick-option-select option").filter(function () {

        return (
            $(this).data("first") == selected[0] &&
            (
                selected.length == 1 ||
                $(this).data("second") == selected[1]
            )
        );

    });

    if (!$variant.length) return;

    const variantId = $variant.data("variantid");
    const variantPrice = $variant.data("var-price");

    // Update hidden inputs
    $modal.find(".final-var-id").val(variantId);
    $modal.find("input[name='id']").val(variantId);

    // Update hidden select
    $modal.find(".quick-option-select")
        .val(variantId)
        .trigger("change");

    // Update price
    $modal.find(".myprice").text(variantPrice);

    console.log(selected);
    console.log("Variant:", variantId);
    console.log("Price:", variantPrice);

});

/* FIX FOR POPUP SURVEY NOT OPENING - WELCOME TO AEROPRESS PAGE */
if (window.location.pathname === "/pages/welcome") {
  /* FIX FOR POPUP SURVEY NOT OPENING - WELCOME TO AEROPRESS PAGE */
  (function () {

    // =========================
    // WAIT FOR JQUERY
    // =========================

    function initSurveyPopup() {

      if (typeof jQuery === 'undefined') {

        setTimeout(initSurveyPopup, 100);

        return;
      }

      const $ = jQuery;

      // OPEN
      $(document).on('click', '.product_survey_btn', function (e) {

        e.preventDefault();

        $('#product_survey_popup')
          .fadeIn(200)
          .css('display', 'flex');

        $('body').addClass('overflow-hidden');

      });

      // CLOSE BUTTON
      $(document).on('click', '.product_survey_close_modal', function () {

        $('#product_survey_popup').fadeOut(200);

        $('body').removeClass('overflow-hidden');

      });

      // CLICK OUTSIDE
      $(document).on('click', '#product_survey_popup', function (e) {

        if ($(e.target).is('#product_survey_popup')) {

          $('#product_survey_popup').fadeOut(200);

          $('body').removeClass('overflow-hidden');

        }

      });

    }

    initSurveyPopup();

  })();
}

jQuery(window).on('load', function () {
  setTimeout(function () {
    document.querySelectorAll(".stamped-review-header-title:empty").forEach(el => {
      el.remove();
    });
  }, 8000);

  $(document).on('click', '.product-picker--item', function () {
    setTimeout(function () {
      document.querySelectorAll(".stamped-review-header-title:empty").forEach(el => {
        el.remove();
      });
    }, 6000);
  });
});